import * as React from 'react';
import { useDispatch } from 'react-redux';

import { FilterMultiChoose } from '../../../../components/FilterMultiChoose';
import { EOfferTypes } from '../../../../constants/searchRealtors';
import { setOfferType } from '../../../../actions/searchRealtors';

const OFFER_TYPES_ITEMS = new Map([
  [EOfferTypes.Flat, 'Жилая'],
  [EOfferTypes.Suburban, 'Загородная'],
  [EOfferTypes.Commercial, 'Коммерческая'],
]);

export const OfferTypeContainer: React.FC = () => {
  const dispatch = useDispatch();

  const handleSelectOfferType = React.useCallback(
    (offerTypes: EOfferTypes[]) => {
      const payload = offerTypes.length ? offerTypes : null;
      dispatch(setOfferType(payload));
    },
    [dispatch],
  );

  return <FilterMultiChoose label="Тип недвижимости" items={OFFER_TYPES_ITEMS} onSelectItem={handleSelectOfferType} />;
};

OfferTypeContainer.displayName = 'OfferTypeContainer';
